import React from "react";
import Layout from "../components/layout";
import { useStaticQuery, graphql } from "gatsby";
import { Row, Col, Card } from "react-bootstrap";

const SkillSet = ({ level, items }) => {
  const skillItems = items.map((skill, key) => <li key={key}>{skill}</li>);

  return (
    <Col>
      {level && <div class="skill-level">{level}</div>}
      <ul>{skillItems}</ul>
    </Col>
  );
};

const Language = ({ skills: { title, levels, items } }) => {
  const basicSkills = [];
  const intermediateSkills = [];
  const advancedSkills = [];

  items.forEach(language => {
    switch (language.level) {
      case levels.basic:
        basicSkills.push(language.title);
        break;
      case levels.intermediate:
        intermediateSkills.push(language.title);
        break;
      case levels.advanced:
        advancedSkills.push(language.title);
        break;
      default:
        break;
    }
  });

  return (
    <Card>
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <Row>
          <SkillSet level={levels.advanced} items={advancedSkills} />
          <SkillSet level={levels.intermediate} items={intermediateSkills} />
          <SkillSet level={levels.basic} items={basicSkills} />
        </Row>
      </Card.Body>
    </Card>
  );
};

const General = ({ title, items }) => {
  return (
    <Card>
      <Card.Header>{title}</Card.Header>
      <Card.Body>
        <Row>
          <SkillSet items={items} />
        </Row>
      </Card.Body>
    </Card>
  );
};

const Electrical = ({ items }) => {
  return (
    <Card>
      <Card.Header>{items.title}</Card.Header>
      <Card.Body>
        <Row>
          <SkillSet level="General Skills" items={items.generalSkills} />
          <SkillSet level="Lab Skills" items={items.labSkills} />
        </Row>
      </Card.Body>
    </Card>
  );
};

const SkillsPage = () => {
  const data = useStaticQuery(graphql`
    {
      dataYaml {
        skills {
          computerLanguages {
            title
            levels {
              advanced
              intermediate
              basic
            }
            items {
              title
              level
            }
          }
          cloud {
            title
            items
          }
          technologies {
            title
            items
          }
          tools {
            title
            items
          }
          electricalEngineering {
            title
            generalSkills
            labSkills
          }
          projectManagement {
            title
            items
          }
          humanLanguages {
            title
            levels {
              advanced
              intermediate
              basic
            }
            items {
              title
              level
            }
          }
        }
      }
    }
  `).dataYaml.skills;

  return (
    <Layout title="Skills">
      <Language skills={data.computerLanguages} />
      <General title={data.cloud.title} items={data.cloud.items} />
      <General
        title={data.technologies.title}
        items={data.technologies.items}
      />
      <General title={data.tools.title} items={data.tools.items} />
      <General
        title={data.projectManagement.title}
        items={data.projectManagement.items}
      />
      <Electrical items={data.electricalEngineering} />
      <Language skills={data.humanLanguages} />
    </Layout>
  );
};

export default SkillsPage;
